/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "../../components/MKBox";
import MKTypography from "../../components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "../../examples/Navbars/DefaultNavbar";
import DefaultFooter from "../../examples/Footers/DefaultFooter";

// Presentation page sections
import Information from "../../pages/Presentation/sections/Information";

// Routes
import routes from "../../routes";
import footerRoutes from "../../footer.routes";

// Images (page-specific photo + shared dark gradient overlay in sx below)
import bgImage from "../../assets/images/vincentiu-solomon.jpeg";

import { createUser } from "../../graphql/mutations";
import { getMe } from "../../graphql/queries";

import { useAuthenticator } from "@aws-amplify/ui-react";

import { Auth, API, graphqlOperation } from "aws-amplify";

var user = {};
var userSession : any;

function Presentation() {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  try {
    Auth.currentSession().then((session) => {
      userSession = session;
      getUser();
    });
  } catch (err) {
    console.log("ERROR:", err);
  }

  const navAction =
    authStatus !== "authenticated"
      ? {
          type: "internal",
          route: "/projects/sign-in",
          label: "sign in",
          color: "info",
        }
      : {
          type: "internal",
          route: "/projects/sign-out",
          label: "sign out",
          color: "info",
        };

  return (
    <MKBox
      sx={{
        minHeight: "100vh",
        backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0.6),
            rgba(gradients.dark.state, 0.6)
          )}, url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <DefaultNavbar routes={routes} action={navAction} sticky />
      {/* DefaultNavbar inner bar is position:absolute, so it does not reserve height — pad enough to clear it */}
      <Container sx={{ pt: { xs: 12, sm: 14, md: 15 }, pb: 4 }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={10} xl={9}>
            <Card
              sx={({ palette: { white }, functions: { rgba }, borders: { borderRadius }, boxShadows }) => ({
                p: { xs: 2, sm: 3 },
                backgroundColor: rgba(white.main, 0.95),
                backdropFilter: "saturate(200%) blur(24px)",
                boxShadow: boxShadows.lg,
                borderRadius: borderRadius.lg,
              })}
            >
              <MKTypography
                variant="h1"
                color="dark"
                textAlign="center"
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                aelchim&apos;s fun stuff{" "}
              </MKTypography>
              <MKTypography
                variant="body1"
                color="text"
                textAlign="center"
                sx={{ opacity: 0.85 }}
                px={{ xs: 0, sm: 2 }}
                mb={4}
              >
                A collection and compilation of all the stuff I do (^_^)
              </MKTypography>
              <Information />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <MKBox
        component="footer"
        sx={({ palette: { white } }) => ({
          backgroundColor: white.main,
          pt: 6,
          pb: 2,
          mt: 4,
        })}
      >
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </MKBox>
  );
}

  async function getUser() {
      try {
        const savedUser : any = await API.graphql(graphqlOperation(getMe))
        if (savedUser.data.getMe) {
          user = savedUser.data.getMe
        } else {
          addUser()
        }
      } catch (err) { console.log(err) }
    }

      async function addUser() {
        try {
        const user: any = {
              username: userSession.idToken.payload["cognito:username"],
              id: userSession.idToken.payload["sub"],
              cognitoId: userSession.idToken.payload["sub"],
              registered: false,
              profilePic: "profilePic.png",
              ethAddress: "",
              about: "",
              wed: 0,
              eth: 0,
              alias: "",
              par: 0,
            };
          await API.graphql(graphqlOperation(createUser, user))
        } catch (err) {
          console.log('error creating user:', err)
        }
      }

export default Presentation;
